import { Stack, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { ROUTES } from '~/shared/constants';

const NotFound = () => {
  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '50vh' }}
    >
      404
      <Button component={Link} to={ROUTES.LOGIN}>
        Go back home
      </Button>
    </Stack>
  );
};

export default NotFound;
